import { createContext, ReactNode, useContext, useState } from 'react';

import { TMessage, TMessageContext } from './types';

const defaultMessage: TMessage = {
  error: '',
  message: '',
};

const MessageContext = createContext<TMessageContext | undefined>(undefined);

export const MessageProvider = ({ children }: { children: ReactNode }) => {
  const [message, setMessage] = useState<TMessage>(defaultMessage);

  return (
    <MessageContext.Provider value={{ message, setMessage }}>{children}</MessageContext.Provider>
  );
};

export const useMessage = (): TMessageContext => {
  const context = useContext(MessageContext);

  if (!context) throw new Error('useMessage must be used within a MessageProvider');
  return context;
};
